import { render, staticRenderFns } from "./ServicoSelect.vue?vue&type=template&id=4cd3e8e5&scoped=true"
import script from "./ServicoSelect.vue?vue&type=script&lang=js"
export * from "./ServicoSelect.vue?vue&type=script&lang=js"
import style0 from "./ServicoSelect.vue?vue&type=style&index=0&id=4cd3e8e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3e8e5",
  null
  
)

export default component.exports